const ROUTES = {
  LOGIN: "/login",
  TWO_FACTOR_AUTHENTICATION: "/authentication",
  PERMISSIONS: "/permissions",
  LOGOUT: "/logout",
  ERROR: "/error",
};

export default ROUTES;
